import axios from "axios";
import { apiConfig } from "./BaseApiService";
export class ClearService {
    constructor(environment) {
        this.environment = environment;
    }
    async getVerificationSession(redirectUrl, isSandbox) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/clear/verify`, { redirectUrl, isSandbox });
        return response.data;
    }
    async getIAL2Url(redirectUrl, authTarget, sandboxMode, heapGlobalEventProperties) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/clear/ial2-url`, { redirectUrl, authTarget, sandboxMode, heapGlobalEventProperties }, apiConfig());
        return response.data;
    }
}
